// extracted by mini-css-extract-plugin
export var resizer = "_hd-0";